const Skeleton = ({ height }) => {
  return (
    <div className="w-full rounded-xl bg-textDisabled/40 animate-pulse" style={{
      height,
    }} />
  )
}

export default Skeleton
